import {  useRef } from 'react';
import { usePUR5010_R01Store } from './Store_PUR5010_R01';
import { Content_PUR5010_R01 } from './Content_PUR5010_R01';
import { SearchSection_PUR5010_R01 } from './SearchSection_PUR5010_R01';
import { Table_PUR5010_R01 } from './Table_PUR5010_R01';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore from 'src/store/useUiuxStore';

export const Container_PUR5010_R01 = () => {
    const { 
        initData: PUR5010_R01initData, 
        PUR5010_R01activeTab, 
    } = usePUR5010_R01Store();

    const { setMessage } = useUiuxStore();

    const { fetchData, handleExcelClick, handleTabChange, columns, data } = Content_PUR5010_R01({
        setMessage
    });

    const gridRef = useRef<any>(null);

    // 권한 체크
    useFetchActionbarAuth('PUR5010_R01');

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onExcelClick={handleExcelClick}
                onCreateClick={() => {}}
                onDeleteClick={() => {}}
                onSaveClick={() => {}}
                onInitClick={PUR5010_R01initData}
            />
            <SearchSection_PUR5010_R01 />
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_PUR5010_R01
                        gridRef={gridRef}
                        tabType={PUR5010_R01activeTab}
                        data={data}
                        columns={columns}
                        onTabChange={handleTabChange}
                    />
                </div>
            </div>
            <Message />
        </div>
    );
};
